import { http, DataBool } from "../base";
import { EmployeeTokenModel } from "../models";

class EmployeeTokenService {
    apiPath = "/api/employeetoken";

    getByEmployeeId(employeeId: string): Promise<EmployeeTokenModel[]> {
        return http.getData(this.apiPath, { employeeId });
    }

    delete(employeeId: string, tokens: string[]): Promise<DataBool<number>> {
        return http.putData(`${this.apiPath}/delete`, { employeeId, tokens });
    }

    deleteAll(employeeId: string): Promise<DataBool<number>> {
        return http.putData(`${this.apiPath}/deleteall?employeeId=${employeeId}`, '');
    }

    clearExpired(employeeId: string): Promise<DataBool<number>> {
        return http.putData(`${this.apiPath}/clearexpired?employeeId=${employeeId}`, '');
    }
}

export const employeeTokenService = new EmployeeTokenService();
